<script setup>
import DOMPurify from 'dompurify'
import {marked} from 'marked'
import {truncate} from '@/helpers/string.js'
import {fixMarkdown} from '@/helpers/markdown.js'
import {computed, toRefs} from 'vue'

//Emits and props
const props = defineProps({
  content: {
    type: String,
    default: '',
  },
  stripTags: {
    type: Boolean,
    default: false,
  },
  maxLength: {
    type: Number,
    default: null,
  },
  ending: {
    type: String,
    default: '...',
  },
})

//Markdown formatting and sanitization
const {content, stripTags, maxLength, ending} = toRefs(props)
const markdown = computed(() => {
  const fixed = fixMarkdown(content.value)
  const truncated = truncate(fixed, maxLength.value, ending.value)
  const markdown = marked.parse(truncated.replace(/\n/g, '  \n'))
  return markdown
})
const sanitized = computed(() => DOMPurify.sanitize(markdown.value, {
  USE_PROFILES: stripTags.value ? undefined : {html: true},
  ALLOWED_TAGS: [],
}))
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    :class="$style.markdown"
    v-html="sanitized"
  />
</template>

<style module>
.markdown {
  &:not(:first-child) {
    margin-top: 1rem;
  }
  p + p, p + ul, p + ol,
  ul + ul, ul + p, ul + ol,
  ol + ol, ol + p, ol + ul
  {
    margin-top: 1rem;
  }
  ol, ul {
    margin-left: 1rem;
    li {
      margin-left: 0.5rem;
    }
  }
  ul {
    list-style: disc;
    line-height: var(--line-height-text);
  }
  ol {
    list-style: decimal;
    line-height: var(--line-height-text);
  }
}
</style>
